import React, { Component } from 'react';
import { Menu, Button, Icon } from 'antd';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { getIncuBaseInfo } from '@store/modules/incubator/incubator_base';
import { BackBtn } from '@comm/BackBtn';
import SelectIncubator from '../SelectIncubator';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: '',
    };
  }

  componentDidMount() {
    const {
      location: { pathname },
      params: { uuid },
    } = this.props;
    this.setState({
      current: pathname.split('/').pop(),
    });
    this.loadData(uuid);
  }

  componentWillMount() {}

  handleClick = e => {
    this.setState({
      current: e.key,
    });
  };

  handleIncuChange = e => {
    const { current } = this.state;
    this.loadData(e);
    browserHistory.replace(`/incubator/one/${e}/detail/${current}`);
  };

  loadData = uuid => {
    this.props.dispatch(getIncuBaseInfo({ uuid }));
  };

  render() {
    const { uuid } = this.props.params;
    const {
      baseInfo,
      // accountInfo
    } = this.props;
    const urlPrefix = `/incubator/one/${uuid}/`;
    return (
      <div className="incubatorOne">
        <div style={{ marginBottom: 15 }} />
        <div
          style={{
            marginBottom: 15,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex' }}>
            <BackBtn />
            <SelectIncubator onChange={this.handleIncuChange} defaultValue={uuid} />
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                marginBottom: '16px',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <div style={{ marginRight: '20px' }}>
                <Icon type="user" />
                <span>{baseInfo.admin}</span>
              </div>
              <div style={{ marginRight: '20px' }}>
                <Icon type="phone" />
                <span>{baseInfo.adminContact}</span>
              </div>
              <Link to={`/incubator/base/edit/${uuid}`}>
                <Button>编辑资料</Button>
              </Link>
            </div>
          </div>
        </div>
        <Menu
          onClick={this.handleClick}
          selectedKeys={[this.state.current]}
          mode="horizontal"
          style={{ marginBottom: '16px' }}
        >
          <Menu.Item key="bill">
            <Link to={`${urlPrefix}detail/bill`}>账单管理</Link>
          </Menu.Item>
          <Menu.Item key="contract">
            <Link to={`${urlPrefix}detail/contract`}>合同管理</Link>
          </Menu.Item>
          <Menu.Item key="custom">
            <Link to={`${urlPrefix}detail/custom`}>客户管理</Link>
          </Menu.Item>
          <Menu.Item key="oregistapp">
            <Link to={`${urlPrefix}detail/oregistapp`}>地址管理</Link>
          </Menu.Item>
          {/* {accountInfo.isIncubatorMng ? (
              <Menu.Item key="finance">
                <Link to={`${urlPrefix}detail/finance`}>财务分析</Link>
              </Menu.Item>
            ) : null} */}
        </Menu>
        {this.props.children}
      </div>
    );
  }
}

export default connect(state => ({
  baseInfo: state.incubator_base,
  accountInfo: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/one/Index.js